import { useTranslation } from "react-i18next";
import styles from "./SurveyCard.module.css";

export default function SurveyCard({ survey, lang }) {
    const { t } = useTranslation();
    return (
        <article className={survey.status ? styles.card : styles.cardDisabled}>
            <header className={styles.header}>
                <h3 className={styles.title}>{survey.title[lang] ?? survey.title.en}</h3>
            </header>
            <dl className={styles.meta}>
                <div className={styles.metaItem}>
                    <dt>{t("surveys.meta.publishSurvey")}</dt>
                    <dd>{survey.publishAt ? survey.publishAt.split('T')[0] : "--:--:--"}</dd>
                    <dt>{t("surveys.meta.endSurvey")}</dt>
                    <dd>{survey.endSurvey}</dd>
                </div>
            </dl>

        </article>
    );
}
